"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _table = _interopRequireDefault(require("../table"));
var _helpers = require("./helpers");
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
const buildHoursData = (rates, index) => {
  const to = rates[index].to;
  const from = index > 0 ? rates[index - 1].to : 0;
  return "".concat((0, _helpers.formatHours)(from)).concat(to ? " - ".concat((0, _helpers.formatHours)(to), " hrs") : ' hrs +');
};
const buildRateString = rate => rate === 0 ? 'Free' : (0, _helpers.formatRate)(rate);
const columns = [{
  key: 'hours',
  heading: 'Hours'
}, {
  key: 'rate',
  heading: 'Rate'
}];
const ParkingRatesTable = _ref => {
  let {
    rates
  } = _ref;
  const rows = rates.map((r, i) => ({
    hours: buildHoursData(rates, i),
    rate: buildRateString(r.rate)
  }));
  return /*#__PURE__*/_react.default.createElement(_table.default, {
    className: _indexModule.default.ratesTable,
    columns: columns,
    rows: rows
  });
};
ParkingRatesTable.propTypes = {
  rates: _propTypes.default.arrayOf(_propTypes.default.shape({
    to: _propTypes.default.number,
    rate: _propTypes.default.number.isRequired
  })).isRequired
};
var _default = exports.default = ParkingRatesTable;